import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class SideBarService {
  public routeSubject$: BehaviorSubject<Route> = new BehaviorSubject(null);
  public route: Route;

  private readonly _sidebarClosedClass = 'c-sidebar--closed';
  private readonly _sidebarOpenClass = 'c-sidebar--open';
  private _showSidebar = false;
  private _sideBarStatus: Object = {};
  private _showSidebarObservable: Subject<boolean>;
  private _statusSidebarObservable: Subject<Object>;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this._showSidebarObservable = new Subject<boolean>();
    this._statusSidebarObservable = new Subject<Object>();
    this._sideBarStatus[this._sidebarClosedClass] = false;
    this._sideBarStatus[this._sidebarOpenClass] = true;

    this.router.events
      .pipe(filter((event: NavigationEnd) => event instanceof NavigationEnd))
      .subscribe(() => {
        let route = this.activatedRoute.snapshot.root.children[0];
        let config = route.routeConfig;
        while (!config.path) {
          route = route.children[0];
          config = route.routeConfig;
        }
        this.routeSubject$.next(config);
        if (this.isToggable() && this.isOpen()) {
          this.toggle();
        }
      });
  }

  public toggle(): void {
    this._sideBarStatus[this._sidebarClosedClass] = !this._sideBarStatus[
      this._sidebarClosedClass
    ];
    this._sideBarStatus[this._sidebarOpenClass] = !this._sideBarStatus[
      this._sidebarOpenClass
    ];
    this._statusSidebarObservable.next(this._sideBarStatus);
  }

  public close(): void {
    this._sideBarStatus[this._sidebarClosedClass] = true;
    this._sideBarStatus[this._sidebarOpenClass] = false;
    this._statusSidebarObservable.next(this._sideBarStatus);
  }

  public open(): void {
    if (this._showSidebar) {
      this._sideBarStatus[this._sidebarOpenClass] = true;
      this._sideBarStatus[this._sidebarClosedClass] = false;
      this._statusSidebarObservable.next(this._sideBarStatus);
    }
  }

  public reset(): void {
    if (this.isToggable()) {
      this._sideBarStatus = {};
      this._statusSidebarObservable.next(this._sideBarStatus);
    }
  }

  public get showSidebarObservable(): Subject<boolean> {
    return this._showSidebarObservable;
  }

  public get statusSidebarObservable(): Subject<Object> {
    return this._statusSidebarObservable;
  }

  private isOpen(): boolean {
    return this._sideBarStatus[this._sidebarOpenClass];
  }

  private isClosed(): boolean {
    return this._sideBarStatus[this._sidebarClosedClass];
  }

  private isToggable(): boolean {
    return this.isOpen() || this.isClosed();
  }
}
